import { z } from 'zod';

const numberOrStringMin1 = z.union([z.string(), z.number()]).refine((v) => {
  if (v === '' || v === null || v === undefined) return false;
  return Number(v) >= 1;
}, 'validation.required');

export const createTenantSchema = z.object({
  name: z.string().min(1, 'validation.required'),
  code: z.string().min(1, 'validation.required'),
  licenseValidUntil: z.string().min(1, 'validation.required'),
  maxPeople: numberOrStringMin1,
  maxDevices: numberOrStringMin1,
  masterUsername: z.string().min(1, 'validation.required'),
  masterEmail: z.string().min(1, 'validation.required').email('validation.emailInvalid'),
  masterDisplayName: z.string().min(1, 'validation.required'),
});

export const updateTenantSchema = z.object({
  name: z.string().min(1, 'validation.required'),
  code: z.string().min(1, 'validation.required'),
  licenseValidUntil: z.string().min(1, 'validation.required'),
  maxPeople: numberOrStringMin1,
  maxDevices: numberOrStringMin1,
});

export const manageAppsSchema = z
  .object({
    applicationIds: z.array(z.string()).min(1, 'validation.required'),
    applicationModules: z.record(z.string(), z.array(z.string())).optional(),
    moduleExpirations: z.record(z.string(), z.string()).optional(),
  })
  .refine(
    (data) => {
      const allModules: string[] = Object.values(data.applicationModules || {}).flat();
      return allModules.length === 0 || allModules.every((mid) => data.moduleExpirations?.[mid]);
    },
    { message: 'validation.required' },
  );
